
import { Component, Mixins } from 'vue-property-decorator';
import WidgetsWrapper from '@/features/dashboard/components/WidgetsWrapper.vue';
import DetailsAside from '@/features/shipment-history/components/details/DetailsAside.vue';
import Welcome from '@/features/dashboard/components/widgets/welcome/index.vue';
import SchedulePickupFlow from '@/features/schedule-pickup/components/SchedulePickupFlow.vue';
import { getDashboardSettings } from '@/features/dashboard/services/dashboard.services';
import WhiteLabelMixin from '@/features/common/mixins/whiteLabelMixin';
import { SchedulePickupMixin } from '@/features/schedule-pickup/components/mixins';
import { ShipmentSummaryItem } from '@/features/shipment-history/types';
import { getShipmentsSummary } from '@/features/shipment-history/services/shipment-history.services';
import eventBus from '@/features/common/eventBus';
import eventNames from '@/features/common/constants/events';

@Component({
  components: {
    WidgetsWrapper,
    DetailsAside,
    Welcome,
    SchedulePickupFlow,
  },
})
export default class Dashboard extends Mixins(WhiteLabelMixin, SchedulePickupMixin) {
  private showShipmentDetails = false;

  private trackingNumberForDetails = '';

  private carrierTrackingNumberForDetails = '';

  private shipmentsSummary: ShipmentSummaryItem[] = [];

  private shipmentAsideTab: 'details' | 'tracking' = 'details';

  get showCustomizeTooltip(): boolean {
    return this.$store.getters.getShowCustomizeTooltip;
  }

  get isLoading(): boolean {
    return this.$store.state.loading;
  }

  created(): void {
    eventBus.$on(eventNames.SHIPMENTS_DELETED, this.onDeleteShipment);
  }

  mounted(): void {
    this.fetchAndCommitDashboardSettingsData();
    this.getShipmentsSummary();
  }

  destroyed(): void {
    this.$store.commit('setDashboardSettings', null);
    eventBus.$off(eventNames.SHIPMENTS_DELETED, this.onDeleteShipment);
  }

  private async fetchAndCommitDashboardSettingsData() {
    const settings = await getDashboardSettings();
    this.$store.commit('setDashboardSettings', settings);
  }

  private async getShipmentsSummary() {
    const shipmentsSummary: ShipmentSummaryItem[] | null = await getShipmentsSummary({
      deleted: false,
    });
    if (!shipmentsSummary) return;

    this.shipmentsSummary = shipmentsSummary;
  }

  private onDeleteShipment(): void {
    setTimeout(() => {
      this.$router.go(0);
    }, 1500);
  }

  private openShipmentDetails(
    { trackingNumber, carrierTrackingNumber },
    tab: 'details' | 'tracking',
  ): void {
    this.shipmentAsideTab = tab;
    this.trackingNumberForDetails = trackingNumber;
    this.carrierTrackingNumberForDetails = carrierTrackingNumber;
    this.showShipmentDetails = true;
  }

  private closeShipmentDetails(): void {
    this.showShipmentDetails = false;
  }
}
